import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Stack } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { useMutation, useQueryClient } from "react-query";
import axiosClient from "../../../../lib/axios";
import { TDataImagens } from "../SideMenu";
import ImageUploadBox from "./ImageUploadBox";
import { useState } from "react";

export default function DialogEditImage({
    open,
    dataImagens,
    onClose,
}: DialogEditImageProps) {

    const queryClient = useQueryClient();

    const [possuiImagemFatura, setPossuiImagemFatura] = useState<boolean>(dataImagens.possui_imagem_fatura || false)
    const [imageFiles, setImageFiles] = useState<TImagePreview>({
        logo_image: dataImagens.logo_image,
        logo_image_url: `${dataImagens.logo_image}`,
        cover_image: dataImagens.cover_image,
        cover_image_url: `${dataImagens.cover_image}`
    })
    //Valores importantes
    const timestamp = new Date().getTime();
    const backgroundImage = imageFiles.cover_image
        ? imageFiles.cover_image instanceof File
            ? `url(${imageFiles.cover_image_url})`
            : `url(${imageFiles.cover_image}?${timestamp})`
        : null;

    const logoImage = imageFiles.logo_image
        ? imageFiles.logo_image instanceof File
            ? `${imageFiles.logo_image_url}`
            : `${imageFiles.logo_image}`
        : `/imgs/image-not-found.png`;
    //
    //Querys e Mutations
    const { mutate: enviarImagem, isLoading } = useMutation({
        mutationKey: 'atualizar-imagem-cooperativa/',
        mutationFn: (inputs: EditImages) => axiosClient.post("/atualizar-imagem-cooperativa/", inputs, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }),
        onSuccess: ({ data }) => {
            enqueueSnackbar(`Imagem atualizada com sucesso!`, { variant: 'success' });
            handleClose();
        },
    })
    //
    //Funções manipuladoras
    const handleFileChange = (prop: keyof TImagePreview, value: FileList | null) => {
        setImageFiles(prevState => ({
            ...prevState,
            [prop]: value ? value[0] : value,
            [`${prop}_url`]: value ? URL.createObjectURL(value[0]) : null
        }))
    }

    const handleSubmit = () => {
        const params: EditImages = {
            logo_image: imageFiles.logo_image,
            cover_image: imageFiles.cover_image,
            possui_imagem_fatura: possuiImagemFatura
        }
        enviarImagem(params)
    }

    const handleClose = async () => {
        await queryClient.invalidateQueries("pesquisar-imagem-cooperativa")
        onClose();
    }
    //

    //Valores importantes
    const valoresSelect = [{ value: false, label: 'Não' }, { value: true, label: 'Sim' }]
    //
    
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={'sm'}
            fullWidth
        >
            <DialogTitle>
                Selecione as imagens para usar no sistema
            </DialogTitle>
            <DialogContent>

                <Box borderRadius={1} display={'flex'} justifyContent={'center'} alignItems={'center'}
                    sx={{
                        backgroundImage: backgroundImage,
                        backgroundRepeat: "no-repeat",
                        backgroundColor: '#cccccc',
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        height: 210
                    }}
                >
                    <Box width={'100%'} height={'100%'} display={'flex'} justifyContent={'center'} alignItems={'center'}
                        sx={{
                            backgroundColor: '#124116',
                            opacity: 0.9,
                        }}
                    >
                        <Box width={110} height={110}
                            display={'flex'} justifyContent={'center'} alignItems={'center'}
                            bgcolor={'#fff'} borderRadius='50%' border={'1px solid #ccc'}>
                            <img
                                src={logoImage}
                                alt="Logo"
                                style={{
                                    width: 100, height: 100,
                                    transform: 'scale(0.7)',
                                    objectFit: 'cover',
                                    objectPosition: 'center bottom',
                                }}
                            />
                        </Box>

                    </Box>
                </Box>
                <ImageUploadBox {...{ handleFileChange, imageFiles }} type="logo_image" />
                <ImageUploadBox {...{ handleFileChange, imageFiles }} type="cover_image" />

                <FormControl fullWidth sx={{ mt: 2 }} required>
                    <Stack direction={'row'} spacing={2} alignItems={'center'}>
                    <FormLabel id={`possui_imagem_fatura`}>Utilizar imagem de fundo nas impressões?</FormLabel>

                    <RadioGroup
                        row
                        aria-labelledby="radioSimOuNao"
                        value={possuiImagemFatura}
                        onChange={(e) => setPossuiImagemFatura(e.target.value === 'true')}
                    >
                        {
                            valoresSelect.map((opcao, index) => (
                                <FormControlLabel key={index} value={opcao.value} control={<Radio />} label={opcao.label} />
                            ))
                        }
                    </RadioGroup>
                    </Stack>
                </FormControl>

            </DialogContent>
            <DialogActions>
                <Button
                    variant="outlined"
                    onClick={handleClose}
                >
                    Cancelar
                </Button>
                <Button
                    onClick={() => handleSubmit()}
                    disabled={isLoading}
                    variant="contained"
                >
                    {isLoading && (
                        <CircularProgress size={14} style={{ marginRight: 12 }} />
                    )}{" "}
                    Enviar
                </Button>
            </DialogActions>
        </Dialog>
    )
}
interface DialogEditImageProps {
    open: boolean;
    onClose: () => void;
    dataImagens: TDataImagens;
}

type EditImages = {
    logo_image?: File | string | null;
    cover_image?: File | string | null;
    possui_imagem_fatura: boolean;
}

export type TImagePreview = {
    logo_image: string | null | File,
    logo_image_url: string | null,
    cover_image: string | null | File,
    cover_image_url: string | null,
}

export type THandleChangeFile = (prop: keyof TImagePreview, value: FileList | null) => void


